import React from 'react';

/**
 * RouteShimmer — ultra-thin gold-thread sweep at the top edge of the viewport.
 *
 * Used as the React.Suspense fallback while route-level lazy chunks load.
 *
 * Design rules:
 *   - 2px tall, top edge only, fixed to viewport, never a spinner
 *   - Single gold thread sweeping left→right, ~1.2s cycle, smooth ease-in-out
 *   - GPU-friendly (translate only, will-change hinted)
 *   - Respects `prefers-reduced-motion`: shows a static, very faint gold line instead
 *
 * Brand feeling: premium airline progress / private-banking loader.
 */

const RouteShimmer = () => (
  <>
    <style>{`
      @keyframes bitzGoldThread {
        0%   { transform: translateX(-100%); opacity: 0; }
        18%  { opacity: 1; }
        82%  { opacity: 1; }
        100% { transform: translateX(200%); opacity: 0; }
      }
      @media (prefers-reduced-motion: reduce) {
        .bitz-route-shimmer-thread {
          animation: none !important;
          opacity: 0.35 !important;
          transform: none !important;
          background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(212,175,55,0.4) 50%,
            transparent 100%
          );
        }
      }
    `}</style>
    <div
      className="fixed top-0 left-0 right-0 h-[2px] z-[100] overflow-hidden pointer-events-none"
      role="progressbar"
      aria-label="Loading"
      data-testid="route-shimmer"
    >
      <div
        className="bitz-route-shimmer-thread absolute inset-y-0 -inset-x-1/4"
        style={{
          background:
            'linear-gradient(90deg, transparent 0%, rgba(212,175,55,0.0) 30%, rgba(245,215,122,0.95) 50%, rgba(212,175,55,0.0) 70%, transparent 100%)',
          animation: 'bitzGoldThread 1.2s cubic-bezier(0.45, 0, 0.25, 1) infinite',
          willChange: 'transform, opacity',
        }}
      />
    </div>
  </>
);

export default RouteShimmer;
